import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _DefaultRceSettings;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { View } from '@instructure/ui-view';
import { jsx } from '@instructure/emotion';
import { Tooltip } from '@instructure/ui-tooltip';
import { IconButton } from '@instructure/ui-buttons';
import { IconInfoLine } from '@instructure/ui-icons';
import { Responsive } from '@instructure/ui-responsive';
import { Text } from '@instructure/ui-text';
import t from '@instructure/quiz-i18n/es/format-message';
import { RichContentRenderer } from '@instructure/quiz-rce';
import { Flex, SimpleSelect, withStyleOverrides } from '@instructure/quiz-common';
import { Setting } from '../Setting';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var DefaultRceSettings = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_DefaultRceSettings = /*#__PURE__*/function (_Component) {
  function DefaultRceSettings() {
    var _this;
    _classCallCheck(this, DefaultRceSettings);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DefaultRceSettings, [].concat(args));
    _defineProperty(_this, "state", {
      errors: {
        hours: null,
        minutes: null
      }
    });
    _defineProperty(_this, "toggleEnabled", function (event, changeCompleteCb) {
      _this.setDefaultRceSettings(changeCompleteCb)({
        enabled: event.target.checked
      });
    });
    _defineProperty(_this, "handleFontChange", function (changeCompleteCb) {
      return function (e, _ref) {
        var id = _ref.id,
          value = _ref.value;
        _this.setDefaultRceSettings(changeCompleteCb)({
          font: value
        });
      };
    });
    _defineProperty(_this, "handleFontSizeChange", function (changeCompleteCb) {
      return function (e, _ref2) {
        var id = _ref2.id,
          value = _ref2.value;
        _this.setDefaultRceSettings(changeCompleteCb)({
          fontSize: value
        });
      };
    });
    _defineProperty(_this, "setDefaultRceSettings", function (changeCompleteCb) {
      return function (newSettings) {
        _this.props.setQuizDefaultRceSettings(_this.props.activeQuizId, _objectSpread(_objectSpread({}, _this.props.defaultRceSettings), newSettings), changeCompleteCb);
      };
    });
    return _this;
  }
  _inherits(DefaultRceSettings, _Component);
  return _createClass(DefaultRceSettings, [{
    key: "settingEnabled",
    get: function get() {
      return this.props.defaultRceSettings.enabled;
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      return jsx("span", null, t('Editor default font'), jsx(Tooltip, {
        renderTip: jsx(View, {
          as: "span",
          display: "inline-block",
          width: "20rem"
        }, t('Changes to font size and type will apply to all rich content by default. However, content with individually set font styles will remain unchanged.')),
        placement: "end",
        on: ['click', 'hover', 'focus']
      }, jsx(IconButton, {
        size: "small",
        renderIcon: IconInfoLine,
        withBackground: false,
        withBorder: false,
        screenReaderLabel: t('Toggle Tooltip')
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var fontOptions = [{
        label: t('Default'),
        value: 'Default'
      }, {
        label: t('Lato'),
        value: "lato, 'Helvetica Neue', Helvetica, Arial, sans-serif"
      }, {
        label: t('Balsamiq Sans'),
        value: "'Balsamiq Sans', lato, 'Helvetica Neue', Helvetica, Arial, sans-serif"
      }, {
        label: t("Architect's Daughter"),
        value: "'Architects Daughter', lato, 'Helvetica Neue', Helvetica, Arial, sans-serif"
      }, {
        label: t('Arial'),
        value: 'arial, helvetica, sans-serif'
      }, {
        label: t('Arial Black'),
        value: "'arial black', 'avant garde'"
      }, {
        label: t('Courier New'),
        value: "'courier new', courier"
      }, {
        label: t('Georgia'),
        value: 'georgia, palatino'
      }, {
        label: t('Tahoma'),
        value: 'tahoma, arial, helvetica, sans-serif'
      }, {
        label: t('Times New Roman'),
        value: "'times new roman', times"
      }, {
        label: t('Trebuchet MS'),
        value: "'trebuchet ms', geneva"
      }, {
        label: t('Verdana'),
        value: 'verdana, geneva'
      }];
      var fontSizeOptions = [{
        label: t('Default'),
        value: 'Default'
      }, {
        label: t('8pt'),
        value: '8pt'
      }, {
        label: t('10pt'),
        value: '10pt'
      }, {
        label: t('12pt'),
        value: '12pt'
      }, {
        label: t('14pt'),
        value: '14pt'
      }, {
        label: t('18pt'),
        value: '18pt'
      }, {
        label: t('24pt'),
        value: '24pt'
      }, {
        label: t('36pt'),
        value: '36pt'
      }];
      return jsx(Setting, {
        automationData: "sdk-default-rce-settings",
        isChecked: this.settingEnabled,
        label: this.renderLabel(),
        onChange: this.toggleEnabled,
        showMore: this.settingEnabled
      }, function (changeCompleteCb) {
        return jsx(Responsive, {
          query: {
            small: {
              maxWidth: '30rem'
            },
            large: {
              minWidth: '30rem'
            }
          },
          props: {
            small: {
              direction: 'column'
            },
            large: {
              direction: 'row'
            }
          }
        }, function (props) {
          return jsx(View, {
            as: "div",
            maxWidth: "30rem"
          }, jsx(Flex, Object.assign({
            justifyItems: "space-between",
            gap: "small"
          }, props), jsx(Flex.Item, {
            shouldGrow: true
          }, jsx(SimpleSelect, {
            renderLabel: t('Font'),
            value: _this2.props.defaultRceSettings.font || 'Default',
            onChange: _this2.handleFontChange(changeCompleteCb)
          }, fontOptions.map(function (_ref3) {
            var label = _ref3.label,
              value = _ref3.value;
            return jsx(SimpleSelect.Option, {
              key: value,
              id: value,
              value: value
            }, label);
          }))), jsx(Flex.Item, {
            shouldGrow: true
          }, jsx(SimpleSelect, {
            renderLabel: t('Font size'),
            value: _this2.props.defaultRceSettings.fontSize || 'Default',
            onChange: _this2.handleFontSizeChange(changeCompleteCb)
          }, fontSizeOptions.map(function (_ref4) {
            var label = _ref4.label,
              value = _ref4.value;
            return jsx(SimpleSelect.Option, {
              key: value,
              id: value,
              value: value
            }, label);
          })))), jsx(View, {
            display: "block",
            margin: "medium 0 0 0"
          }, jsx(Text, {
            weight: "bold"
          }, t('Preview')), jsx(View, {
            display: "block",
            padding: "small",
            margin: "small 0 0 0",
            background: "secondary",
            borderWidth: "small",
            borderRadius: "medium"
          }, jsx(RichContentRenderer, {
            content: t('Example text')
          }))));
        });
      });
    }
  }]);
}(Component), _defineProperty(_DefaultRceSettings, "displayName", 'DefaultRceSettings'), _defineProperty(_DefaultRceSettings, "componentId", "Quizzes".concat(_DefaultRceSettings.displayName)), _defineProperty(_DefaultRceSettings, "propTypes", {
  defaultRceSettings: PropTypes.shape({
    enabled: PropTypes.bool,
    font: PropTypes.string,
    fontSize: PropTypes.string
  }),
  activeQuizId: PropTypes.string.isRequired,
  setQuizDefaultRceSettings: PropTypes.func.isRequired,
  styles: PropTypes.object
}), _defineProperty(_DefaultRceSettings, "defaultProps", {
  defaultRceSettings: {
    enabled: false
  }
}), _DefaultRceSettings)) || _class);
export default DefaultRceSettings;